const primary = '#ff832a';
const dark = '#000';

export default {
  primary,
  dark
}
